import Orders from './components';

export default {
  protected: true,
  path: '/orders/:vendorId',
  key: '/orders/',
  exact: true,
  component: Orders,
};
